import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/submission';

export default {
	getSubmissions(params, cb, errorCb) {
		// const query = buildQuery(params);
		// const url = `${endpoint}?${query}`;
		const url = `${endpoint}`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getDetailOrders(id, params, cb, errorCb) {
		let url = `${endpoint}/${id}?`;

		if (params.is_deleted) {
			url += `is_deleted=${params.is_deleted}`;
		}

		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getOrderDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}/details?store_info=1&skip_deleted=true`;

		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateProgress(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/progress`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	setStatus(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/status`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	setBulkStatus(params, cb, errorCb) {
		const url = `${endpoint}/status/bulk`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	setPaymentStatus(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/payment_status`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	setBulkPaymentStatus(params, cb, errorCb) {
		const url = `${endpoint}/payment_status/bulk`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	sendSMS(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/send_sms`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	bulkDelete(ids = [], cb, errorCb) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			submission_ids: idsJSON,
		};

		client.delete(url, { data: params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	export(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	updatePrinted(ids = [], cb, errorCb) {
		const url = `${endpoint}/is_printed`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			submission_ids: idsJSON,
		};

		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	uploadReceipt(params, cb, errorCb) {
		const url = `${endpoint}/receipt_numbers`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	updateTag(params, cb, errorCb) {
		const url = `${endpoint}/tag`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	setAssignToTeam(params, cb, errorCb) {
		const url = `${endpoint}/belongs_to`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Update Customer Data Only for Instant Payment Method
	updateCustomer(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/customer`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getCancelledSubmissionIds(cb, errorCb) {
		const url = `${endpoint}/cancelled-submission`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	cancelledNoticeReaded(cb, errorCb) {
		const url = `${endpoint}/readed-cancelled-submission`;
		client.get(url)
			.then(() => {
				cb();
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
